import { LocalizedLink } from "@/components/LocalizedLink";
import SeoServicesNav from "@/components/SeoServicesNav";
import { useLocale } from "@/locale/LocaleProvider";
import { pickOfferSite } from "@/locale/content/offerSite";
import {
  SITE_EMAIL,
  SITE_NEXOPS_URL,
  SITE_PHONE_DISPLAY,
  SITE_PHONE_E164,
  SITE_TELEGRAM_HANDLE,
  SITE_TELEGRAM_URL,
} from "@/lib/siteContact";
import { trackContactClick } from "@/lib/analytics";

export default function SiteFooter() {
  const { lang } = useLocale();
  const copy = pickOfferSite(lang);
  const year = new Date().getFullYear();

  return (
    <>
      <div className="site-a-seo-nav border-t border-[var(--a-border)] bg-[var(--a-bg-elevated)] [&_section]:border-0 [&_section]:bg-transparent [&_h2]:font-display [&_h2]:text-[var(--a-fg)] [&_p]:text-[var(--a-muted)] [&_a]:min-h-11 [&_a]:border-[var(--a-border)] [&_a]:bg-[var(--a-card)] [&_a]:text-[var(--a-fg)] [&_a]:shadow-none [&_a:hover]:border-[var(--a-primary)]/40 [&_a:hover]:bg-[var(--a-accent-soft)] [&_a:hover]:text-[var(--a-primary-hover)] [&_a[aria-current=page]]:border-[var(--a-primary)]/50 [&_a[aria-current=page]]:bg-[var(--a-accent-soft)] [&_a[aria-current=page]]:text-[var(--a-primary)]">
        <SeoServicesNav />
      </div>
      <footer className="border-t border-[var(--a-border)] bg-[var(--a-bg)] text-[var(--a-muted)]">
        <div className="mx-auto grid max-w-6xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-3">
          <div>
            <LocalizedLink to="/" className="font-display text-xl font-semibold text-[var(--a-fg)]">
              IT<span className="text-[var(--a-primary)]">-24</span>
            </LocalizedLink>
            <p className="mt-4 max-w-sm text-sm leading-relaxed">{copy.footerTagline}</p>
            <p className="mt-5 text-xs text-[var(--a-muted)]/80">
              {copy.footerEuNote}:{" "}
              <a
                href={SITE_NEXOPS_URL}
                className="font-medium text-[var(--a-primary)] transition hover:text-[var(--a-primary-hover)]"
                rel="noopener noreferrer"
              >
                {copy.footerEuLink}
              </a>
            </p>
          </div>

          <div>
            <h3 className="mb-4 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[var(--a-muted)]">
              {copy.nav.services}
            </h3>
            <ul className="space-y-2.5 text-sm">
              {copy.offers.map((o) => (
                <li key={o.id}>
                  <LocalizedLink to={o.href} className="transition hover:text-[var(--a-primary)]">
                    {o.title}
                  </LocalizedLink>
                </li>
              ))}
              <li>
                <LocalizedLink to="/cases" className="transition hover:text-[var(--a-primary)]">
                  {copy.nav.cases}
                </LocalizedLink>
              </li>
              <li>
                <LocalizedLink to="/about" className="transition hover:text-[var(--a-primary)]">
                  {copy.nav.about}
                </LocalizedLink>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[var(--a-muted)]">
              {copy.nav.contacts}
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={SITE_TELEGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium text-[var(--a-primary)] transition hover:text-[var(--a-primary-hover)]"
                  onClick={() => trackContactClick("telegram")}
                >
                  Telegram {SITE_TELEGRAM_HANDLE}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE_EMAIL}`}
                  className="transition hover:text-[var(--a-primary)]"
                  onClick={() => trackContactClick("email")}
                >
                  {SITE_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${SITE_PHONE_E164}`}
                  className="transition hover:text-[var(--a-primary)]"
                  onClick={() => trackContactClick("phone")}
                >
                  {SITE_PHONE_DISPLAY}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[var(--a-border)] py-5 text-center font-mono text-[11px] tracking-wide text-[var(--a-muted)]/70">
          © {year} IT-24.pro
        </div>
      </footer>
    </>
  );
}
